import { LABELS } from '@/constants/common/message.constants'

import { type TruckSpecificationEntity } from '../..'

/**
 * 荷台床面種別
 */
export type CargoAreaFloorType = Exclude<
  TruckSpecificationEntity['cargoAreaFloorType'],
  null
>

export const CARGO_AREA_FLOOR_TYPE = {
  /** 鉄板 */
  STEEL: 'STEEL',
  /** 縞板 */
  CHECKERED: 'CHECKERED',
  /** すのこ */
  SLATTED: 'SLATTED',
  /** 木張 */
  WOODEN: 'WOODEN'
} as const satisfies Record<CargoAreaFloorType, CargoAreaFloorType>

export const CARGO_AREA_FLOOR_TYPE_LABEL = {
  [CARGO_AREA_FLOOR_TYPE.STEEL]: LABELS.STEEL,
  [CARGO_AREA_FLOOR_TYPE.CHECKERED]: LABELS.CHECKERED,
  [CARGO_AREA_FLOOR_TYPE.SLATTED]: LABELS.SLATTED,
  [CARGO_AREA_FLOOR_TYPE.WOODEN]: LABELS.WOODEN
} as const satisfies Record<CargoAreaFloorType, string>
